import { render, staticRenderFns } from "./Provisioning-Activate-Subscriber-Simple.vue?vue&type=template&id=510ec94b"
import script from "./Provisioning-Activate-Subscriber-Simple.vue?vue&type=script&lang=js"
export * from "./Provisioning-Activate-Subscriber-Simple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports